import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { getTranslation } from '../translations';
import './LegalPage.css';
import { isLayoutDemo } from '../demo';

const Privacy = () => {
  const { language } = useLanguage();
  const t = getTranslation(language);

  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1>{t.privacy.title}</h1>
        {isLayoutDemo && <p className="legal-review-note">{language === 'zh' ? '政策页面布局预览：本地演示表单不发送或保存信息。以下沿用文本需由公司确认后才作为正式隐私政策发布。' : 'Policy layout preview: the local demo form does not send or save information. The retained text below requires company review before publication as a final policy.'}</p>}
        <p className="legal-updated">{t.privacy.lastUpdated}: {language === 'zh' ? '2026年10月14日' : 'October 14, 2026'}</p>
        <section>
          <h2>{language === 'zh' ? '官网咨询表单' : 'Website inquiry form'}</h2>
          <p>{language === 'zh'
            ? '提交咨询时，我们保存您的姓名、邮箱、机构、咨询类型、留言、提交时间和隐私确认记录，用于处理及回复咨询。记录保存在服务器上与公开网站文件分离的私有目录中；提交不会自动发送邮件。如需及时跟进，请直接联系页面中对应的邮箱。'
            : 'When you submit an inquiry, we save your name, email, organization, inquiry type, message, submission time and privacy acknowledgement to handle and respond to your inquiry. Records are stored in a private server directory separate from public website files. Submission does not automatically send an email; for time-sensitive follow-up, please contact the relevant email address directly.'}</p>
          <p>{language === 'zh'
            ? '表单会临时使用连接地址进行提交频率限制，咨询记录中不保存该地址。请勿提交密码或敏感个人信息。您可以通过下方邮箱申请查询、更正或删除咨询记录，并提供咨询编号。'
            : 'The form temporarily uses the connection address to limit submission attempts; that address is not stored in the inquiry record. Please do not submit passwords or sensitive personal information. You can request access, correction or deletion of an inquiry through the email below, quoting its reference.'}</p>
        </section>
        <section>
          <h2>{language === 'zh' ? '语言与视频' : 'Language and video'}</h2>
          <p>{language === 'zh'
            ? '网站在浏览器本地保存您选择的语言。宣传视频播放器只会在您点击加载后连接第三方视频平台；届时该平台会按照其自身隐私规则处理连接信息。您也可以通过备用链接直接在视频平台观看。'
            : 'The website saves your language preference locally in your browser. The company video player connects to its third-party provider only after you click to load it; the provider then handles connection information under its own privacy rules. You can also use the direct viewing link.'}</p>
        </section>
        
        <section>
          <h2>{t.privacy.section1.title}</h2>
          <p>{t.privacy.section1.content}</p>
        </section>

        <section>
          <h2>{t.privacy.section2.title}</h2>
          <p>{t.privacy.section2.content}</p>
        </section>

        <section>
          <h2>{t.privacy.section3.title}</h2>
          <p>{t.privacy.section3.content}</p>
        </section>

        <section>
          <h2>{t.privacy.section4.title}</h2>
          <p>{t.privacy.section4.content}</p>
        </section>

        <section>
          <h2>{t.privacy.contact.title}</h2>
          <p>{t.privacy.contact.content}</p>
          <p><a href="mailto:jinhuqi@agentecfusion.com">jinhuqi@agentecfusion.com</a></p>
        </section>
      </div>
    </div>
  );
};

export default Privacy;
